const enGb = {
    general:{
        next: "Next",
        previousSelection: "Your previous selection:",
        change: "Change",
        person: "Person",
        persons: "Persons",
        from: "From",
        to: "To",
        reserveNow: "Reserve now",
        moreInfo: "Provide more details",
        yes: "yes",
        no: "No",
        clock: "O' clock",
        date:{
            from: "Date From",
            to: "Date To",
        },
        time:{
            from: "Time From",
            to: "Time To",
        },
        inclusiveTax: "incl. VAT",
        per: "per",
        emptyResult: "Could not find any {type} for the selected resource {resource}"
    },
    startPage: {
        title: "What event would you like to plan?",
        subtitle: "Please make a selection",
        metaTitle: "Event Configurator"
    },
    personDetails: {
        title: "How many people take part ?",
        subtitle: "Please enter a number",
        metaTitle: "How many people take part ?",
        number: "Number"
    },
    seatingType:{
        title: "Which seating would you like?",
        subtitle: "Please make a selection",
        metaTitle: "Which seating would you like?",
    },
    scheduleDuration:{
        title: "When will your event take place ?",
        subtitle: "Please specify date and time",
        metaTitle: "When will your event take place ?",
        bookingBlocked: "The online booking of events over several days is not yet supported. Please call us at (0821) 4551260. We will be happy to provide you with an individual offer."
    },
    slotAvailability: {
        availableTitle: "Available!",
        availableSubtitle: "Reserve now or provide more details about your event",
        notAvailableTitle: "Occupied!",
        notAvailableSubtitle: "We are already fully booked for your requested date",
        moreDateTitle: "Which date suits you?",
        moreDateSubtitle: "Select an appointment.",
        moreDates: "Further dates",
        currentPrice: "Your current price: *",
        priceInfo: "* non-binding price suggestion",
        vatInfo: "incl. VAT.",
        changeAppointment: "Change Appointment",
        showAvailability: "Show Available Dates",
        unavailableInfo: "Not found an appointment?",
        unavailableInfoText: "Just contact us. {phoneNumber}",
        maxDepthReached: "Sorry! We could not find any suitable other dates that match your criteria. Please contact us for a better arrangement",
        changeDate: "Back to date selection"
    },
    inventory:{
        title: "What equipment do you need?",
        subtitle: "Please make a selection.",
        metaTitle: "What equipment do you need?",
    },
    services:{
        title: "What services do you need?",
        subtitle: "Please make a selection.",
        metaTitle: "What services do you need?",
    },
    additionalInfo:{
        title: "Please provide further details",
        subtitle: "",
        metaTitle: "Please provide further details",
        overNightStay: "Would you like to receive a separate offer for an overnight stay in the house? *",
        notice: "* data will be transmitted to the {resourceName} more.",

        otherWishTitle: "What other wishes do you have?",
        otherWishSubtitle: "Optionally, you can leave us a message.",
        otherWishPlaceholder: "Your message."
    },
    checkout: {
        title: "Please enter your data:",
        subtitle: "",
        metaTitle: "Please enter your data:",
        company: "Company",
        firstname: "firstname",
        lastname: "LastName",
        email: "Email",
        phone: "Phone",
        street: "Street",
        zip: "Postal code",
        city: "City",
        tosLink: "I have read and accept the <a href='{url}' rel='noopener' target='_blank'>terms and conditions</a>.",
        tos: "I have read and accept the <a href='{url}' onclick='return false' rel='noopener' target='_blank'>terms and conditions</a>.",
        privacyTextLink: "I have read the <a href='{url}' rel='noopener' target='_blank'>privacy policy</a>.",
        privacyText: "I have read the <a href='{url}'  onclick='return false' rel='noopener' target='_blank'>privacy policy</a>.",
        infoText: "* non-binding price suggestion"
    },

    finish: {
        title: "Thank you very much! <br /><br /> We have received your reservation and will get back to you as soon as possible.",
        subtitle: "",
        metaTitle: "Thank you very much! We have received your reservation and will get back to you as soon as possible.",
        planNext: "Plan next event",
        anyQuestion: "Any questions?",
        contactInfo: "Just contact us. {phoneNumber}",
    },
    errors:{
        company: "Please enter a valid company name",
        firstname: "Oops! Looks like your first name is having problems",
        lastname: "Last name doesn't look good",
        email: "Please make sure your email address is valid",
        phone: "Please provide a valid phone number",
        zip: "Please enter a valid zip code",
        city: "Please enter a valid city",
        street: "Please enter a valid street",
        invalidEmailFormat: 'Oops! invalid email format'
    },

    404: {
        title: "Oops! This obviously isn't a page you were looking for.",
        subtitle: "Please, let us know how you got here, and use one of the following links to navigate back to safe harbor.",
        metaTitle: "Oops! This obviously isn't a page you were looking for.",
        home: {
          title: "Home",
          url: "/"
        },
        locaboo: {
            title: "Locaboo GmbH",
            url: "https://www.locaboo.com/"
        },
        westHouse: {
            title: "WestHouse",
            url: "#"
        },
        contact: {
            title: "Contact",
            url: "https://www.locaboo.com/kontakt"
        }

    }
}

export default enGb;



// WEBPACK FOOTER //
// ./src/translation/en.js